import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// ====== RELLENA AQUI TUS DATOS ANTES DE PUBLICAR (se muestran en el aviso legal y la privacidad) ======
export const LEGAL_OWNER = {
  name: 'Peter Emmanuel Prophete',
  nif: 'Z0447672M',
  address: 'Calle de la Esfinge, 17, 28022 Madrid, Espa\u00f1a',
  email: 'hola@getflashmultiservice.com',
  web: 'app.getflashmultiservice.com',
};
export const LEGAL_UPDATED = '29 de octubre de 2026';
// ======================================================================================================

const DOCS = {
 "aviso-legal": {
  "title": "Aviso legal y condiciones de uso",
  "blocks": [
   [
    "h",
    "1. Datos del titular"
   ],
   [
    "p",
    "En cumplimiento del art\u00edculo 10 de la Ley 34/2002, de servicios de la sociedad de la informaci\u00f3n y de comercio electr\u00f3nico (LSSI-CE), se informa de los datos del titular de este sitio web y del servicio Flash Multiservice:"
   ],
   [
    "ul",
    [
     "Titular: {name} (persona f\u00edsica, trabajador aut\u00f3nomo)",
     "NIF: {nif}",
     "Domicilio: {address}",
     "Email de contacto: {email}",
     "Sitio web: {web}"
    ]
   ],
   [
    "h",
    "2. Objeto"
   ],
   [
    "p",
    "Flash Multiservice es una aplicaci\u00f3n web (software como servicio) que permite a tiendas online reunir sus pedidos, productos, costes y gasto en publicidad para calcular su ganancia real, analizar el cat\u00e1logo p\u00fablico de otras tiendas y consultar tendencias de b\u00fasqueda. Este aviso regula el acceso al sitio web y el uso del servicio."
   ],
   [
    "h",
    "3. Condiciones de uso"
   ],
   [
    "p",
    "Al registrarte o usar el servicio te comprometes a:"
   ],
   [
    "ul",
    [
     "Usarlo de forma l\u00edcita y solo para gestionar tu propio negocio.",
     "No intentar acceder a datos de otras empresas ni a partes del sistema a las que no tengas acceso.",
     "No usar el esp\u00eda de competencia ni otras funciones para recopilar datos de forma masiva, sobrecargar sitios de terceros o infringir sus condiciones.",
     "Mantener tu contrase\u00f1a en secreto y avisarnos si sospechas de un uso no autorizado de tu cuenta.",
     "Tener derecho a tratar los datos que conectes o importes, incluidos los de los compradores de tu tienda."
    ]
   ],
   [
    "p",
    "Podemos suspender o cerrar las cuentas que incumplan estas condiciones."
   ],
   [
    "h",
    "4. Planes, pagos y cancelaci\u00f3n"
   ],
   [
    "p",
    "Los planes y sus precios se indican en la web. El pago es mensual y se gestiona a trav\u00e9s de Stripe; no almacenamos los datos de tu tarjeta. La suscripci\u00f3n se renueva autom\u00e1ticamente cada mes hasta que la canceles. Puedes cancelarla en cualquier momento desde Planes y facturaci\u00f3n, sin permanencia; la cancelaci\u00f3n se aplica seg\u00fan lo indicado en el portal de facturaci\u00f3n."
   ],
   [
    "h",
    "5. Alcance de la informaci\u00f3n"
   ],
   [
    "p",
    "Los c\u00e1lculos de ganancia real, m\u00e1rgenes e IVA dependen de los datos que t\u00fa introduces o conectas (costes, r\u00e9gimen de IVA, comisiones, gasto en anuncios) y son orientativos. No sustituyen el asesoramiento contable, fiscal o legal. La informaci\u00f3n de tiendas de terceros y de tendencias de b\u00fasqueda procede de fuentes p\u00fablicas y se ofrece sin garant\u00eda de exactitud ni de disponibilidad."
   ],
   [
    "h",
    "6. Responsabilidad"
   ],
   [
    "p",
    "Trabajamos para que el servicio funcione de forma continua y segura, pero no podemos garantizar que est\u00e9 libre de interrupciones o errores, en particular cuando dependen de proveedores externos (alojamiento, plataformas de comercio electr\u00f3nico, pasarelas de pago). En la medida permitida por la ley, no respondemos de decisiones de negocio tomadas a partir de la informaci\u00f3n mostrada."
   ],
   [
    "h",
    "7. Propiedad intelectual"
   ],
   [
    "p",
    "El software, el dise\u00f1o, la marca Flash Multiservice y los contenidos del sitio pertenecen a su titular o a sus licenciantes. Los datos de tu negocio son tuyos: los usamos solo para prestarte el servicio, como se explica en la pol\u00edtica de privacidad."
   ],
   [
    "h",
    "8. Enlaces a terceros"
   ],
   [
    "p",
    "El servicio puede mostrar enlaces a sitios de terceros (por ejemplo, productos de tiendas analizadas). No somos responsables de su contenido."
   ],
   [
    "h",
    "9. Legislaci\u00f3n aplicable"
   ],
   [
    "p",
    "Estas condiciones se rigen por la legislaci\u00f3n espa\u00f1ola. Para cualquier controversia, las partes se someten a los juzgados y tribunales de Madrid, salvo que la normativa aplicable establezca otro fuero."
   ]
  ]
 },
 "privacidad": {
  "title": "Pol\u00edtica de privacidad",
  "blocks": [
   [
    "h",
    "1. Responsable del tratamiento"
   ],
   [
    "ul",
    [
     "Responsable: {name}",
     "NIF: {nif}",
     "Domicilio: {address}",
     "Contacto para privacidad: {email}"
    ]
   ],
   [
    "h",
    "2. Qu\u00e9 datos tratamos"
   ],
   [
    "ul",
    [
     "Datos de cuenta: email y contrase\u00f1a (la contrase\u00f1a se guarda cifrada por nuestro proveedor de autenticaci\u00f3n; nunca la vemos).",
     "Datos de tu empresa: nombre, pa\u00eds, moneda, r\u00e9gimen de IVA y ajustes de la cuenta.",
     "Datos de facturaci\u00f3n: los gestiona Stripe. Nosotros solo guardamos el identificador de cliente y el plan contratado.",
     "Datos de tu negocio que conectas o importas: pedidos, productos, costes, stock y gasto en publicidad. Los pedidos pueden incluir el nombre y el email de tus compradores.",
     "Datos t\u00e9cnicos: direcci\u00f3n IP, registros de acceso e intentos de inicio de sesi\u00f3n, para la seguridad del servicio.",
     "Informe gratis de competencia (sin registro): la direcci\u00f3n de la tienda analizada y tu IP, solo para limitar abusos. La IP se guarda en memoria y se descarta en una hora."
    ]
   ],
   [
    "h",
    "3. Para qu\u00e9 los usamos y base legal"
   ],
   [
    "ul",
    [
     "Prestarte el servicio y mantener tu cuenta (ejecuci\u00f3n del contrato, art. 6.1.b RGPD).",
     "Enviarte emails necesarios: verificaci\u00f3n, recuperaci\u00f3n de contrase\u00f1a, invitaciones y las alertas que t\u00fa configures (ejecuci\u00f3n del contrato).",
     "Facturar y cumplir obligaciones contables y fiscales (obligaci\u00f3n legal, art. 6.1.c RGPD).",
     "Proteger el servicio frente a accesos no autorizados y abusos (inter\u00e9s leg\u00edtimo, art. 6.1.f RGPD)."
    ]
   ],
   [
    "p",
    "No vendemos tus datos ni los de tus compradores, no los cedemos a terceros con fines comerciales y no te enviamos publicidad sin tu consentimiento."
   ],
   [
    "h",
    "4. Datos de tus compradores"
   ],
   [
    "p",
    "Respecto a los datos de los compradores de tu tienda que entren en la aplicaci\u00f3n, t\u00fa eres el responsable del tratamiento y nosotros actuamos como encargado del tratamiento (art. 28 RGPD): los tratamos solo para prestarte el servicio y siguiendo tus instrucciones. Si necesitas un contrato de encargo del tratamiento, p\u00eddelo en {email}."
   ],
   [
    "h",
    "5. Cu\u00e1nto tiempo los conservamos"
   ],
   [
    "p",
    "Mientras tu cuenta est\u00e9 activa. El propietario puede eliminarla en cualquier momento desde Configuraci\u00f3n \u2192 Eliminar cuenta: al hacerlo se cancela la suscripci\u00f3n y se borran al momento todos los datos de la empresa (productos, pedidos, conexiones, automatizaciones) y los usuarios del equipo. Solo conservamos lo que debamos guardar por obligaci\u00f3n legal (por ejemplo, los datos de facturaci\u00f3n, que gestiona Stripe, durante los plazos que exige la normativa mercantil y tributaria). Los datos borrados pueden permanecer durante un breve periodo en las copias de seguridad autom\u00e1ticas, hasta que se sobrescriben. Los registros t\u00e9cnicos se conservan durante un periodo limitado."
   ],
   [
    "h",
    "6. Proveedores que tratan datos por nuestra cuenta"
   ],
   [
    "ul",
    [
     "Supabase: base de datos y autenticaci\u00f3n. Servidores en Frankfurt (Uni\u00f3n Europea).",
     "Railway: alojamiento de la aplicaci\u00f3n. Servidores en \u00c1msterdam (Uni\u00f3n Europea).",
     "Stripe: pagos y suscripciones.",
     "Resend: env\u00edo de emails.",
     "Cloudflare: DNS, seguridad y reenv\u00edo de correo.",
     "SerpAPI: consultas de tendencias de b\u00fasqueda (solo recibe los t\u00e9rminos buscados, sin datos personales).",
     "Integraciones que t\u00fa activas: Shopify, WooCommerce, TikTok Shop, Meta (anuncios) y Slack. Al conectarlas, intercambiamos con ellas los datos necesarios para la integraci\u00f3n."
    ]
   ],
   [
    "p",
    "Algunos de estos proveedores tienen sede en Estados Unidos. En esos casos, las transferencias internacionales se realizan con las garant\u00edas previstas en el RGPD, como el Marco de Privacidad de Datos UE-EE. UU. o las cl\u00e1usulas contractuales tipo de la Comisi\u00f3n Europea."
   ],
   [
    "h",
    "7. Tus derechos"
   ],
   [
    "p",
    "Puedes ejercer tus derechos de acceso, rectificaci\u00f3n, supresi\u00f3n, oposici\u00f3n, limitaci\u00f3n del tratamiento y portabilidad escribiendo a {email}, indicando qu\u00e9 derecho ejerces. La supresi\u00f3n de tu cuenta y de todos sus datos tambi\u00e9n puedes hacerla t\u00fa mismo desde Configuraci\u00f3n \u2192 Eliminar cuenta. Si consideras que no hemos atendido bien tu solicitud, puedes reclamar ante la Agencia Espa\u00f1ola de Protecci\u00f3n de Datos (www.aepd.es)."
   ],
   [
    "h",
    "8. Seguridad"
   ],
   [
    "p",
    "Toda la comunicaci\u00f3n con la aplicaci\u00f3n va cifrada (HTTPS), cada empresa solo puede ver sus propios datos y el acceso al sistema est\u00e1 restringido. Si detectamos una brecha de seguridad que afecte a tus datos, te lo comunicaremos seg\u00fan lo previsto en la normativa."
   ],
   [
    "h",
    "9. Cambios"
   ],
   [
    "p",
    "Si cambiamos esta pol\u00edtica de forma importante, te avisaremos por email o en la aplicaci\u00f3n."
   ]
  ]
 },
 "cookies": {
  "title": "Pol\u00edtica de cookies",
  "blocks": [
   [
    "h",
    "1. Qu\u00e9 usamos"
   ],
   [
    "p",
    "Flash Multiservice no usa cookies propias ni de terceros con fines anal\u00edticos, publicitarios o de seguimiento."
   ],
   [
    "p",
    "Solo guardamos en tu navegador (almacenamiento local) la informaci\u00f3n t\u00e9cnica imprescindible para que la aplicaci\u00f3n funcione:"
   ],
   [
    "ul",
    [
     "Sesi\u00f3n: mantiene tu sesi\u00f3n iniciada mientras usas la aplicaci\u00f3n.",
     "Idioma (omniflow_language): recuerda el idioma que has elegido.",
     "Preferencias del panel (omniflow_noads_months): recuerda avisos que ya has descartado.",
     "Cach\u00e9 de la aplicaci\u00f3n: permite instalarla como app y cargarla m\u00e1s r\u00e1pido."
    ]
   ],
   [
    "p",
    "Al ser estrictamente necesarios para prestar el servicio que solicitas, no requieren tu consentimiento (art\u00edculo 22.2 de la LSSI-CE)."
   ],
   [
    "h",
    "2. Servicios de terceros"
   ],
   [
    "p",
    "Cuando pagas una suscripci\u00f3n, se te redirige a la p\u00e1gina de pago de Stripe, que puede usar sus propias cookies en su dominio. Puedes consultarlas en la pol\u00edtica de privacidad y cookies de Stripe."
   ],
   [
    "h",
    "3. C\u00f3mo borrarlas"
   ],
   [
    "p",
    "Puedes borrar en cualquier momento el almacenamiento local y las cookies desde la configuraci\u00f3n de tu navegador. Si lo haces, se cerrar\u00e1 tu sesi\u00f3n y se perder\u00e1n tus preferencias."
   ],
   [
    "h",
    "4. Cambios"
   ],
   [
    "p",
    "Si en el futuro a\u00f1adimos herramientas de anal\u00edtica o publicidad, actualizaremos esta pol\u00edtica y te pediremos el consentimiento antes de activarlas."
   ]
  ]
 }
};

const fill = (text) => text.replace(/\{(name|nif|address|email|web)\}/g, (m, k) => LEGAL_OWNER[k]);

function Legal() {
  const location = useLocation();
  const key = location.pathname.replace('/', '');
  const doc = DOCS[key] || DOCS['aviso-legal'];

  return (
    <div className="bg-panel min-h-screen font-sans text-white">
      <div className="border-b border-edge">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between gap-4">
          <Link to="/" className="no-underline">
            <span className="block text-accent text-lg font-extrabold leading-tight">Flash Multiservice</span>
            <span className="block text-muted text-[11px]">Business Intelligence</span>
          </Link>
          <nav className="flex flex-wrap gap-4 text-xs">
            <Link to="/aviso-legal" className={key === 'aviso-legal' ? 'text-accent' : 'text-[#999]'}>{'Aviso legal'}</Link>
            <Link to="/privacidad" className={key === 'privacidad' ? 'text-accent' : 'text-[#999]'}>{'Privacidad'}</Link>
            <Link to="/cookies" className={key === 'cookies' ? 'text-accent' : 'text-[#999]'}>{'Cookies'}</Link>
          </nav>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-white text-2xl sm:text-3xl font-bold mb-2">{doc.title}</h1>
        <p className="text-muted text-xs mb-8">{'\u00daltima actualizaci\u00f3n: '}{LEGAL_UPDATED}</p>
        {doc.blocks.map(([type, value], i) => {
          if (type === 'h') return <h2 key={i} className="text-white text-base font-semibold mt-8 mb-3">{value}</h2>;
          if (type === 'ul') {
            return (
              <ul key={i} className="list-disc pl-5 mb-4 flex flex-col gap-1.5">
                {value.map((item, j) => <li key={j} className="text-[#bbb] text-sm leading-relaxed">{fill(item)}</li>)}
              </ul>
            );
          }
          return <p key={i} className="text-[#bbb] text-sm leading-relaxed mb-4">{fill(value)}</p>;
        })}
      </div>
    </div>
  );
}

export default Legal;
